module.exports = __webpack_public_path__ + "static/img/2.6b710ec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/4/eng/2.png
// module id = zB89
// module chunks = 0